import { z } from 'zod';
import type { AlignedHistory } from '../result-history';

/**
 * A patient's earlier results for the same test.
 *
 * `AlignedHistory` is computed by `shared/result-history.ts` and travels
 * whole — the alignment is the answer, and re-deriving it on the client would
 * be a second implementation of the rule that a paper report and a screen must
 * never disagree about which visit a value came from.
 */

export const reportHistoryQuerySchema = z.object({
  /**
   * How many earlier visits to fetch.
   *
   * Two by default, which is what requirement 7 asks for on paper. The
   * comparison screen asks for more; twelve is the ceiling because a table
   * thirteen columns wide stops being readable and the query stops being an
   * index scan.
   */
  limit: z.coerce.number().int().min(1).max(12).default(2),
});
export type ReportHistoryQuery = z.infer<typeof reportHistoryQuerySchema>;

export interface ReportHistory {
  report_id: number;
  patient_id: number;
  test_id: number;
  /** The report's own snapshotted test name — what this sheet is called. */
  test_name: string;
  history: AlignedHistory;
}
